<template>
	<div>
		<CRow>
			<CCol sm="12">
				<CCard>
					<CCardHeader> Gestion des tickets </CCardHeader>

					<CCardBody>
						<GDataTableRemote
							ref="mainTable"
							remote-url="/api/support_tickets"
							:fields="fields"
							:items-per-page="10"
							hover
							striped
							sorter
							columnFilter
							pagination>
							<template #status="{ item }">
								<td>
									<CBadge :color="statusColor[item.status]">{{
										statusTranslation[item.status]
									}}</CBadge>
								</td>
							</template>

							<template #conversationStatus="{ item }">
								<td>
									<CBadge :color="conversationStatusColor[item.conversationStatus]">{{
										conversationStatusTranslation[item.conversationStatus]
									}}</CBadge>
								</td>
							</template>

							<template #responsibleActor="{ item }">
								<td>
									<CBadge :color="responsibleActorColor[item.responsibleActor]">
										{{ responsibleActorTranslation[item.responsibleActor] }}
									</CBadge>
								</td>
							</template>

							<template #search_expeditor="{ item }">
								<td v-if="item.orderItem && item.orderItem.parentOrder.senderAddress">
									{{
										`${item.orderItem.parentOrder.senderAddress.firstName} ${item.orderItem.parentOrder.senderAddress.lastName} | ${item.orderItem.parentOrder.senderAddress.address}, ${item.orderItem.parentOrder.senderAddress.postalCode} ${item.orderItem.parentOrder.senderAddress.city}`
									}}
								</td>
								<td v-else>
									<CIcon name="cil-ban" />
								</td>
							</template>

							<template #search_receiver="{ item }">
								<td>
									<template v-if="item.orderItem && item.orderItem.receiverAddress">
										{{
											`${item.orderItem.receiverAddress.firstName} ${item.orderItem.receiverAddress.lastName} | ${item.orderItem.receiverAddress.address}, ${item.orderItem.receiverAddress.postalCode} ${item.orderItem.receiverAddress.city}`
										}}
									</template>
									<template v-else>
										<CIcon name="cil-ban" />
									</template>
								</td>
							</template>

							<template #actions="{ item }">
								<td class="text-center">
									<button class="btn btn-link" @click="gotoTicket(item)">
										<CIcon name="cil-pencil" />
									</button>
								</td>
							</template>
						</GDataTableRemote>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>
<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';

	export default {
		components: {
			GDataTableRemote,
		},

		data() {
			this.statusOptions = [
				{
					value: 'support_ticket.status.new',
					label: 'Nouveau',
				},
				{
					value: 'support_ticket.status.ongoing',
					label: 'En cours de traitement',
				},
				{
					value: 'support_ticket.status.closed',
					label: 'Clôturé',
				},
				{
					value: 'support_ticket.status.awaiting_decision',
					label: 'En attente de décision',
				},
			];

			this.conversationStatus = [
				{
					value: 'support_ticket.conversation.client_response',
					label: 'Le client a répondu',
				},
				{
					value: 'support_ticket.conversation.sav_response',
					label: 'Le SAV a répondu',
				},
			];

			return {
				fields: [
					{ key: 'id', label: '#' },
					{
						key: 'status',
						label: 'Statut',
						type: 'select',
						filterSelectOptions: this.statusOptions,
					},
					{
						key: 'conversationStatus',
						label: 'Conversation',
						type: 'select',
						filterSelectOptions: this.conversationStatus,
					},
					{ key: 'orderItem.id', label: 'N° Colis' },
					{ key: 'orderItem.name', label: 'Type' },
					{ key: 'orderItem.shippingNumber', label: 'N° Suivi' },
					{ key: 'search_expeditor', label: 'Expéditeur', sorter: false },
					{ key: 'search_receiver', label: 'Destinataire', sorter: false },
					{
						key: 'responsibleActor',
						label: 'Responsable',
						type: 'select',
						filterSelectOptions: [
							{ value: 'support_ticket.responsible.colipays', label: 'Colipays' },
							{ value: 'support_ticket.responsible.chronopost', label: 'Chronopost' },
							{ value: 'support_ticket.responsible.customer', label: 'Client' },
						],
					},
					{ key: 'createdAt', label: 'Création du ticket', type: 'daterange' },
					{ key: 'updatedAt', label: 'Dernière mise à jour', type: 'daterange' },
					{ key: 'actions', filter: false },
				],
				statusTranslation: {
					'support_ticket.status.new': 'Nouveau',
					'support_ticket.status.ongoing': 'En cours de traitement',
					'support_ticket.status.closed': 'Clôturé',
					'support_ticket.status.awaiting_decision': 'En attente de décision',
				},
				statusColor: {
					'support_ticket.status.new': 'info',
					'support_ticket.status.ongoing': 'warning',
					'support_ticket.status.closed': 'danger',
					'support_ticket.status.awaiting_decision': 'warning',
				},
				conversationStatusTranslation: {
					'support_ticket.conversation.client_response': 'Le client a répondu',
					'support_ticket.conversation.sav_response': 'Le SAV a répondu',
				},
				conversationStatusColor: {
					'support_ticket.conversation.client_response': 'warning',
					'support_ticket.conversation.sav_response': 'success',
				},
				responsibleActorTranslation: {
					'support_ticket.responsible.colipays': 'Colipays',
					'support_ticket.responsible.chronopost': 'Chronopost',
					'support_ticket.responsible.customer': 'Client',
				},
				responsibleActorColor: {
					'support_ticket.responsible.colipays': 'warning',
					'support_ticket.responsible.chronopost': 'danger',
					'support_ticket.responsible.customer': 'success',
				},
				customer: false,
			};
		},

		methods: {
			async gotoTicket(ticket) {
				if (ticket.status === 'support_ticket.status.new') {
					await this.$axios.patch(
						ticket['@id'],
						{
							status: 'support_ticket.status.ongoing',
						},
						{
							headers: {
								'Content-Type': 'application/merge-patch+json',
							},
						}
					);
				}

				await this.$router.push(`tickets/${ticket.id}/edit`);
			},
			refresh: function () {
				this.$refs.mainTable.refresh();
			},
		},
	};
</script>
